export default [
  {
    path: 'red-packet',
    name: 'redPacket',
    meta: {
      isDynamic: true,
      id: '红包奖励',
      inTab: true
    },
    component: () => import('@/views/activity/RedPacket/index.vue')
  },
  {
    path: 'activity-update',
    name: 'ActivityUpdate',
    meta: {
      id: '红包奖励活动更新'
    },
    component: () => import('@/views/activity/RedPacket/activity-update.vue')
  },
  {
    path: 'preferential-purchase',
    name: 'PreferentialPurchase',
    meta: {
      isDynamic: true,
      id: '超值换购',
      inTab: true
    },
    component: () => import('@/views/activity/PreferentialPurchase/index.vue')
  },
  {
    path: 'vote-activity',
    name: 'VoteActivity',
    meta: {
      isDynamic: true,
      id: '评选竞赛',
      inTab: true
    },
    component: () => import('@/views/activity/VoteActivity/VoteActivity.vue')
  },
  {
    path: 'purchase-activity-update',
    name: 'PurchaseActivityUpdate',
    component: () => import('@/views/activity/PreferentialPurchase/activity-update.vue')
  }
];
